// import React from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom'

import Navbar from "./components/header";
import Footer from "./components/footer";

import Home from "./pages/index";
import About from "./pages/about";
import Services from './pages/services';
import Partners from './pages/partner'
import Contact from './pages/contact';


export default function Routers () {
    return (
      <Router>
          <Navbar />

           <Routes>
                <Route path="/" exact element={<Home/>}/>
                <Route path="/about" exact element={<About/>}/>
                <Route path="/services" exact element={<Services/>}/>
                <Route path="/partners" exact element={<Partners/>}/>
                <Route path="/contact" exact element={<Contact/>}/>
          </Routes>

          <Footer/>
       </Router>
      )
}